export default "/images/adobe-photoshop.svg?1fb5c34343073e70e33683f7e1917857";